// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3XVEl","buttons":"SendReceipts_buttons__1UKOj","email":"SendReceipts_email__1iMXy","bookApptTitle":"SendReceipts_bookApptTitle__25FIc"};